export function isMaskedEmail(expected: string, actual: string): boolean {
  if (expected === actual) {
    return false;
  }

  if (expected.endsWith("@sonymusic-pde.com")) {
    throw new Error(
      "Unexpected email mismatch between prod and target environment",
    );
  }

  return true;
}
